import {
  Package,
  PackageCheck,
  ShoppingCart,
  Truck,
  FileText,
  LayoutDashboard,
  Plus,
  Clock,
  History,
  ArrowLeftRight,
  CheckSquare,
  Link,
  BarChart3,
  BarChart2,
  Activity,
  Euro,
  Users,
  Home,
  ScanLine,
  ScanBarcode,
  ClipboardList,
  Mail,
  Archive,
  Sparkles,
  AlertTriangle,
  Tag,
  ScrollText,
  UserCheck,
  QrCode,
  Timer,
  BookUser,
  Bell,
  ShieldCheck,
  Database,
  BookOpen,
  Zap,
  Shield,
  Umbrella,
  Gift,
  Calendar,
  Sun,
  Lightbulb,
  FileDown,
  ClipboardCheck,
  HeartPulse,
  GraduationCap,
  Target,
  PieChart,
  PhoneCall,
  Settings,
  Mic,
  AudioLines,
  Wrench,
  MessageSquare,
  UserRound,
  FolderUp,
  FileSearch,
  Inbox,
  Layout,
  Calculator,
  UserMinus,
  Megaphone,
  Scale,
  TrendingUp,
  SlidersHorizontal,
  UserPlus,
  Lock,
  Tv,
  Monitor,
  List,
  ListVideo,
  CalendarDays,
  Presentation,
  Clapperboard,
  Film,
  type LucideIcon,
} from 'lucide-react';

export const sidebarIconMap: Record<string, LucideIcon> = {
  Package,
  PackageCheck,
  ShoppingCart,
  Truck,
  FileText,
  LayoutDashboard,
  Plus,
  Clock,
  History,
  ArrowLeftRight,
  CheckSquare,
  Link,
  BarChart3,
  BarChart2,
  Activity,
  Euro,
  Users,
  Home,
  ScanLine,
  ScanBarcode,
  ClipboardList,
  Mail,
  Archive,
  Sparkles,
  AlertTriangle,
  Tag,
  ScrollText,
  UserCheck,
  QrCode,
  Timer,
  BookUser,
  Bell,
  ShieldCheck,
  Database,
  BookOpen,
  Zap,
  Shield,
  Umbrella,
  Gift,
  Calendar,
  Sun,
  Lightbulb,
  FileDown,
  ClipboardCheck,
  HeartPulse,
  GraduationCap,
  Target,
  PieChart,
  PhoneCall,
  Settings,
  Mic,
  AudioLines,
  Wrench,
  MessageSquare,
  UserRound,
  FolderUp,
  FileSearch,
  Inbox,
  HardDriveUpload: FolderUp,
  Layout,
  Calculator,
  UserMinus,
  Megaphone,
  Scale,
  TrendingUp,
  SlidersHorizontal,
  UserPlus,
  Lock,
  Tv,
  Monitor,
  List,
  ListVideo,
  CalendarDays,
  Presentation,
  Clapperboard,
  Film,
};
